export default "__VITE_ASSET__DJ1F1KpI__"